import { Component, Input } from '@angular/core';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-no-results',
    templateUrl: './no-results.component.html',
    styleUrls: ['./no-results.component.scss'],
    standalone: false
})
export class NoResultsComponent {
  @Input() message:string=''
  @Input() customMessage:boolean=false
  totalResults: number | undefined;
  hideNoResults: boolean;
  translations: any;

  constructor(private translationservice:TranslationService) {
    this.hideNoResults = true;
  }

  ngOnInit() {
    this.translationservice.getTranslation().subscribe(data => {
      this.translations = data;
      if(!this.customMessage)
      {
        this.message = this.translations['noResultText'];
      }
      
    });
  }

  setTotal(total: number): void {
    this.totalResults = total;
    this.hideNoResults = this.totalResults != undefined && this.totalResults > 0;
  }
}
